import script from "./TabStatPills.vue?vue&type=script&setup=true&lang=ts"
export * from "./TabStatPills.vue?vue&type=script&setup=true&lang=ts"

import "./TabStatPills.vue?vue&type=style&index=0&id=a81523f2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a81523f2"]])

export default __exports__